export const countries = [
  {
    country_id: 1,
    name: 'Afghanistan',
    capital: 'Kabul',
    format: null,
    calling_code: '+93',
    emoji: '🇦🇫',
  },
  {
    country_id: 2,
    name: 'Albania',
    capital: 'Tirana',
    format: null,
    calling_code: '+355',
    emoji: '🇦🇱',
  },
  {
    country_id: 3,
    name: 'Algeria',
    capital: 'Algiers',
    format: null,
    calling_code: '+213',
    emoji: '🇩🇿',
  },
  {
    country_id: 4,
    name: 'American Samoa',
    capital: 'Pago Pago',
    format: null,
    calling_code: '+1 684',
    emoji: '🇦🇸',
  },
  {
    country_id: 5,
    name: 'Andorra',
    capital: 'Andorra la Vella',
    format: null,
    calling_code: '+376',
    emoji: '🇦🇩',
  },
  {
    country_id: 6,
    name: 'Angola',
    capital: 'Luanda',
    format: null,
    calling_code: '+244',
    emoji: '🇦🇴',
  },
  {
    country_id: 7,
    name: 'Anguilla',
    capital: 'The Valley',
    format: null,
    calling_code: '+1 264',
    emoji: '🇦🇮',
  },
  {
    country_id: 8,
    name: 'Antarctica',
    capital: 'Unknown',
    format: null,
    calling_code: '+672',
    emoji: '🇦🇶',
  },
  {
    country_id: 9,
    name: 'Antigua and Barbuda',
    capital: "Saint John's",
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 10,
    name: 'Argentina',
    capital: 'Buenos Aires',
    format: null,
    calling_code: '+54',
    emoji: '🇦🇷',
  },
  {
    country_id: 11,
    name: 'Armenia',
    capital: 'Yerevan',
    format: null,
    calling_code: '+374',
    emoji: '🇦🇲',
  },
  {
    country_id: 12,
    name: 'Aruba',
    capital: 'Oranjestad',
    format: null,
    calling_code: '+297',
    emoji: '🇦🇼',
  },
  {
    country_id: 13,
    name: 'Australia',
    capital: 'Canberra',
    format: null,
    calling_code: '+61',
    emoji: '🇦🇺',
  },
  {
    country_id: 14,
    name: 'Austria',
    capital: 'Vienna',
    format: null,
    calling_code: '+43',
    emoji: '🇦🇹',
  },
  {
    country_id: 15,
    name: 'Azerbaijan',
    capital: 'Baku',
    format: null,
    calling_code: '+994',
    emoji: '🇦🇿',
  },
  {
    country_id: 16,
    name: 'Bahamas',
    capital: 'Nassau',
    format: null,
    calling_code: '+1 242',
    emoji: '🇧🇸',
  },
  {
    country_id: 17,
    name: 'Bahrain',
    capital: 'Manama',
    format: null,
    calling_code: '+973',
    emoji: '🇧🇭',
  },
  {
    country_id: 18,
    name: 'Bangladesh',
    capital: 'Dhaka',
    format: null,
    calling_code: '+880',
    emoji: '🇧🇩',
  },
  {
    country_id: 19,
    name: 'Barbados',
    capital: 'Bridgetown',
    format: null,
    calling_code: '+1 246',
    emoji: '🇧🇧',
  },
  {
    country_id: 20,
    name: 'Belarus',
    capital: 'Minsk',
    format: null,
    calling_code: '+375',
    emoji: '🇧🇾',
  },
  {
    country_id: 21,
    name: 'Belgium',
    capital: 'Brussels',
    format: null,
    calling_code: '+32',
    emoji: '🇧🇪',
  },
  {
    country_id: 22,
    name: 'Belize',
    capital: 'Belmopan',
    format: null,
    calling_code: '+501',
    emoji: '🇧🇿',
  },
  {
    country_id: 23,
    name: 'Benin',
    capital: 'Porto-Novo',
    format: null,
    calling_code: '+229',
    emoji: '🇧🇯',
  },
  {
    country_id: 24,
    name: 'Bermuda',
    capital: 'Hamilton',
    format: null,
    calling_code: '+1 441',
    emoji: '🇧🇲',
  },
  {
    country_id: 25,
    name: 'Bhutan',
    capital: 'Thimphu',
    format: null,
    calling_code: '+975',
    emoji: '🇧🇹',
  },
  {
    country_id: 26,
    name: 'Bolivia',
    capital: 'Sucre',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 27,
    name: 'Bosnia and Herzegovina',
    capital: 'Sarajevo',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 28,
    name: 'Botswana',
    capital: 'Gaborone',
    format: null,
    calling_code: '+267',
    emoji: '🇧🇼',
  },
  {
    country_id: 29,
    name: 'Bouvet Island',
    capital: 'Unknown',
    format: null,
    calling_code: '',
    emoji: '🇧🇻',
  },
  {
    country_id: 30,
    name: 'Brazil',
    capital: 'Brasília',
    format: null,
    calling_code: '+55',
    emoji: '🇧🇷',
  },
  {
    country_id: 31,
    name: 'British Indian Ocean Territory',
    capital: 'Diego Garcia',
    format: null,
    calling_code: '+246',
    emoji: '🇮🇴',
  },
  {
    country_id: 32,
    name: 'British Virgin Islands',
    capital: 'Road Town',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 33,
    name: 'Brunei',
    capital: 'Bandar Seri Begawan',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 34,
    name: 'Bulgaria',
    capital: 'Sofia',
    format: null,
    calling_code: '+359',
    emoji: '🇧🇬',
  },
  {
    country_id: 35,
    name: 'Burkina Faso',
    capital: 'Ouagadougou',
    format: null,
    calling_code: '+226',
    emoji: '🇧🇫',
  },
  {
    country_id: 36,
    name: 'Burundi',
    capital: 'Gitega',
    format: null,
    calling_code: '+257',
    emoji: '🇧🇮',
  },
  {
    country_id: 37,
    name: 'Cambodia',
    capital: 'Phnom Penh',
    format: null,
    calling_code: '+855',
    emoji: '🇰🇭',
  },
  {
    country_id: 38,
    name: 'Cameroon',
    capital: 'Yaoundé',
    format: null,
    calling_code: '+237',
    emoji: '🇨🇲',
  },
  {
    country_id: 39,
    name: 'Canada',
    capital: 'Ottawa',
    format: null,
    calling_code: '+1',
    emoji: '🇨🇦',
  },
  {
    country_id: 40,
    name: 'Cape Verde',
    capital: 'Praia',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 41,
    name: 'Caribbean Netherlands',
    capital: 'Kralendijk',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 42,
    name: 'Cayman Islands',
    capital: 'George Town',
    format: null,
    calling_code: '+1 345',
    emoji: '🇰🇾',
  },
  {
    country_id: 43,
    name: 'Central African Republic',
    capital: 'Bangui',
    format: null,
    calling_code: '+236',
    emoji: '🇨🇫',
  },
  {
    country_id: 44,
    name: 'Chad',
    capital: "N'Djamena",
    format: null,
    calling_code: '+235',
    emoji: '🇹🇩',
  },
  {
    country_id: 45,
    name: 'Chile',
    capital: 'Santiago',
    format: null,
    calling_code: '+56',
    emoji: '🇨🇱',
  },
  {
    country_id: 46,
    name: 'China',
    capital: 'Beijing',
    format: null,
    calling_code: '+86',
    emoji: '🇨🇳',
  },
  {
    country_id: 47,
    name: 'Christmas Island',
    capital: 'Flying Fish Cove',
    format: null,
    calling_code: '+61',
    emoji: '🇨🇽',
  },
  {
    country_id: 48,
    name: 'Cocos (Keeling) Islands',
    capital: 'West Island',
    format: null,
    calling_code: '+61',
    emoji: '🇨🇨',
  },
  {
    country_id: 49,
    name: 'Colombia',
    capital: 'Bogotá',
    format: null,
    calling_code: '+57',
    emoji: '🇨🇴',
  },
  {
    country_id: 50,
    name: 'Comoros',
    capital: 'Moroni',
    format: null,
    calling_code: '+269',
    emoji: '🇰🇲',
  },
  {
    country_id: 51,
    name: 'Cook Islands',
    capital: 'Avarua',
    format: null,
    calling_code: '+682',
    emoji: '🇨🇰',
  },
  {
    country_id: 52,
    name: 'Costa Rica',
    capital: 'San José',
    format: null,
    calling_code: '+506',
    emoji: '🇨🇷',
  },
  {
    country_id: 53,
    name: 'Croatia',
    capital: 'Zagreb',
    format: null,
    calling_code: '+385',
    emoji: '🇭🇷',
  },
  {
    country_id: 54,
    name: 'Cuba',
    capital: 'Havana',
    format: null,
    calling_code: '+53',
    emoji: '🇨🇺',
  },
  {
    country_id: 55,
    name: 'Curaçao',
    capital: 'Willemstad',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 56,
    name: 'Cyprus',
    capital: 'Nicosia',
    format: null,
    calling_code: '+357',
    emoji: '🇨🇾',
  },
  {
    country_id: 57,
    name: 'Czechia',
    capital: 'Prague',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 58,
    name: 'DR Congo',
    capital: 'Kinshasa',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 59,
    name: 'Denmark',
    capital: 'Copenhagen',
    format: null,
    calling_code: '+45',
    emoji: '🇩🇰',
  },
  {
    country_id: 60,
    name: 'Djibouti',
    capital: 'Djibouti',
    format: null,
    calling_code: '+253',
    emoji: '🇩🇯',
  },
  {
    country_id: 61,
    name: 'Dominica',
    capital: 'Roseau',
    format: null,
    calling_code: '+1 767',
    emoji: '🇩🇲',
  },
  {
    country_id: 62,
    name: 'Dominican Republic',
    capital: 'Santo Domingo',
    format: null,
    calling_code: '+1 809',
    emoji: '🇩🇴',
  },
  {
    country_id: 63,
    name: 'Ecuador',
    capital: 'Quito',
    format: null,
    calling_code: '+593',
    emoji: '🇪🇨',
  },
  {
    country_id: 64,
    name: 'Egypt',
    capital: 'Cairo',
    format: null,
    calling_code: '+20',
    emoji: '🇪🇬',
  },
  {
    country_id: 65,
    name: 'El Salvador',
    capital: 'San Salvador',
    format: null,
    calling_code: '+503',
    emoji: '🇸🇻',
  },
  {
    country_id: 66,
    name: 'Equatorial Guinea',
    capital: 'Malabo',
    format: null,
    calling_code: '+240',
    emoji: '🇬🇶',
  },
  {
    country_id: 67,
    name: 'Eritrea',
    capital: 'Asmara',
    format: null,
    calling_code: '+291',
    emoji: '🇪🇷',
  },
  {
    country_id: 68,
    name: 'Estonia',
    capital: 'Tallinn',
    format: null,
    calling_code: '+372',
    emoji: '🇪🇪',
  },
  {
    country_id: 69,
    name: 'Eswatini',
    capital: 'Mbabane',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 70,
    name: 'Ethiopia',
    capital: 'Addis Ababa',
    format: null,
    calling_code: '+251',
    emoji: '🇪🇹',
  },
  {
    country_id: 71,
    name: 'Falkland Islands',
    capital: 'Stanley',
    format: null,
    calling_code: '+500',
    emoji: '🇫🇰',
  },
  {
    country_id: 72,
    name: 'Faroe Islands',
    capital: 'Tórshavn',
    format: null,
    calling_code: '+298',
    emoji: '🇫🇴',
  },
  {
    country_id: 73,
    name: 'Fiji',
    capital: 'Suva',
    format: null,
    calling_code: '+679',
    emoji: '🇫🇯',
  },
  {
    country_id: 74,
    name: 'Finland',
    capital: 'Helsinki',
    format: null,
    calling_code: '+358',
    emoji: '🇫🇮',
  },
  {
    country_id: 75,
    name: 'France',
    capital: 'Paris',
    format: null,
    calling_code: '+33',
    emoji: '🇫🇷',
  },
  {
    country_id: 76,
    name: 'French Guiana',
    capital: 'Cayenne',
    format: null,
    calling_code: '+594',
    emoji: '🇬🇫',
  },
  {
    country_id: 77,
    name: 'French Polynesia',
    capital: 'Papeetē',
    format: null,
    calling_code: '+689',
    emoji: '🇵🇫',
  },
  {
    country_id: 78,
    name: 'French Southern and Antarctic Lands',
    capital: 'Port-aux-Français',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 79,
    name: 'Gabon',
    capital: 'Libreville',
    format: null,
    calling_code: '+241',
    emoji: '🇬🇦',
  },
  {
    country_id: 80,
    name: 'Gambia',
    capital: 'Banjul',
    format: null,
    calling_code: '+220',
    emoji: '🇬🇲',
  },
  {
    country_id: 81,
    name: 'Georgia',
    capital: 'Tbilisi',
    format: null,
    calling_code: '+995',
    emoji: '🇬🇪',
  },
  {
    country_id: 82,
    name: 'Germany',
    capital: 'Berlin',
    format: null,
    calling_code: '+49',
    emoji: '🇩🇪',
  },
  {
    country_id: 83,
    name: 'Ghana',
    capital: 'Accra',
    format: null,
    calling_code: '+233',
    emoji: '🇬🇭',
  },
  {
    country_id: 84,
    name: 'Gibraltar',
    capital: 'Gibraltar',
    format: null,
    calling_code: '+350',
    emoji: '🇬🇮',
  },
  {
    country_id: 85,
    name: 'Greece',
    capital: 'Athens',
    format: null,
    calling_code: '+30',
    emoji: '🇬🇷',
  },
  {
    country_id: 86,
    name: 'Greenland',
    capital: 'Nuuk',
    format: null,
    calling_code: '+299',
    emoji: '🇬🇱',
  },
  {
    country_id: 87,
    name: 'Grenada',
    capital: "St. George's",
    format: null,
    calling_code: '+473',
    emoji: '🇬🇩',
  },
  {
    country_id: 88,
    name: 'Guadeloupe',
    capital: 'Basse-Terre',
    format: null,
    calling_code: '+590',
    emoji: '🇬🇵',
  },
  {
    country_id: 89,
    name: 'Guam',
    capital: 'Hagåtña',
    format: null,
    calling_code: '+1 671',
    emoji: '🇬🇺',
  },
  {
    country_id: 90,
    name: 'Guatemala',
    capital: 'Guatemala City',
    format: null,
    calling_code: '+502',
    emoji: '🇬🇹',
  },
  {
    country_id: 91,
    name: 'Guernsey',
    capital: 'St. Peter Port',
    format: null,
    calling_code: '+44',
    emoji: '🇬🇬',
  },
  {
    country_id: 92,
    name: 'Guinea',
    capital: 'Conakry',
    format: null,
    calling_code: '+224',
    emoji: '🇬🇳',
  },
  {
    country_id: 93,
    name: 'Guinea-Bissau',
    capital: 'Bissau',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 94,
    name: 'Guyana',
    capital: 'Georgetown',
    format: null,
    calling_code: '+592',
    emoji: '🇬🇾',
  },
  {
    country_id: 95,
    name: 'Haiti',
    capital: 'Port-au-Prince',
    format: null,
    calling_code: '+509',
    emoji: '🇭🇹',
  },
  {
    country_id: 96,
    name: 'Heard Island and McDonald Islands',
    capital: 'Unknown',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 97,
    name: 'Honduras',
    capital: 'Tegucigalpa',
    format: null,
    calling_code: '+504',
    emoji: '🇭🇳',
  },
  {
    country_id: 98,
    name: 'Hong Kong',
    capital: 'City of Victoria',
    format: null,
    calling_code: '+852',
    emoji: '🇭🇰',
  },
  {
    country_id: 99,
    name: 'Hungary',
    capital: 'Budapest',
    format: null,
    calling_code: '+36',
    emoji: '🇭🇺',
  },
  {
    country_id: 100,
    name: 'Iceland',
    capital: 'Reykjavik',
    format: null,
    calling_code: '+354',
    emoji: '🇮🇸',
  },
  {
    country_id: 101,
    name: 'India',
    capital: 'New Delhi',
    format: null,
    calling_code: '+91',
    emoji: '🇮🇳',
  },
  {
    country_id: 102,
    name: 'Indonesia',
    capital: 'Jakarta',
    format: null,
    calling_code: '+62',
    emoji: '🇮🇩',
  },
  {
    country_id: 103,
    name: 'Iran',
    capital: 'Tehran',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 104,
    name: 'Iraq',
    capital: 'Baghdad',
    format: null,
    calling_code: '+964',
    emoji: '🇮🇶',
  },
  {
    country_id: 105,
    name: 'Ireland',
    capital: 'Dublin',
    format: null,
    calling_code: '+353',
    emoji: '🇮🇪',
  },
  {
    country_id: 106,
    name: 'Isle of Man',
    capital: 'Douglas',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 107,
    name: 'Israel',
    capital: 'Jerusalem',
    format: null,
    calling_code: '+972',
    emoji: '🇮🇱',
  },
  {
    country_id: 108,
    name: 'Italy',
    capital: 'Rome',
    format: null,
    calling_code: '+39',
    emoji: '🇮🇹',
  },
  {
    country_id: 109,
    name: 'Ivory Coast',
    capital: 'Yamoussoukro',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 110,
    name: 'Jamaica',
    capital: 'Kingston',
    format: null,
    calling_code: '+1 876',
    emoji: '🇯🇲',
  },
  {
    country_id: 111,
    name: 'Japan',
    capital: 'Tokyo',
    format: null,
    calling_code: '+81',
    emoji: '🇯🇵',
  },
  {
    country_id: 112,
    name: 'Jersey',
    capital: 'Saint Helier',
    format: null,
    calling_code: '+44',
    emoji: '🇯🇪',
  },
  {
    country_id: 113,
    name: 'Jordan',
    capital: 'Amman',
    format: null,
    calling_code: '+962',
    emoji: '🇯🇴',
  },
  {
    country_id: 114,
    name: 'Kazakhstan',
    capital: 'Nur-Sultan',
    format: null,
    calling_code: '+7',
    emoji: '🇰🇿',
  },
  {
    country_id: 115,
    name: 'Kenya',
    capital: 'Nairobi',
    format: null,
    calling_code: '+254',
    emoji: '🇰🇪',
  },
  {
    country_id: 116,
    name: 'Kiribati',
    capital: 'South Tarawa',
    format: null,
    calling_code: '+686',
    emoji: '🇰🇮',
  },
  {
    country_id: 117,
    name: 'Kosovo',
    capital: 'Pristina',
    format: null,
    calling_code: '+383',
    emoji: '',
  },
  {
    country_id: 118,
    name: 'Kuwait',
    capital: 'Kuwait City',
    format: null,
    calling_code: '+965',
    emoji: '🇰🇼',
  },
  {
    country_id: 119,
    name: 'Kyrgyzstan',
    capital: 'Bishkek',
    format: null,
    calling_code: '+996',
    emoji: '🇰🇬',
  },
  {
    country_id: 120,
    name: 'Laos',
    capital: 'Vientiane',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 121,
    name: 'Latvia',
    capital: 'Riga',
    format: null,
    calling_code: '+371',
    emoji: '🇱🇻',
  },
  {
    country_id: 122,
    name: 'Lebanon',
    capital: 'Beirut',
    format: null,
    calling_code: '+961',
    emoji: '🇱🇧',
  },
  {
    country_id: 123,
    name: 'Lesotho',
    capital: 'Maseru',
    format: null,
    calling_code: '+266',
    emoji: '🇱🇸',
  },
  {
    country_id: 124,
    name: 'Liberia',
    capital: 'Monrovia',
    format: null,
    calling_code: '+231',
    emoji: '🇱🇷',
  },
  {
    country_id: 125,
    name: 'Libya',
    capital: 'Tripoli',
    format: null,
    calling_code: '+218',
    emoji: '🇱🇾',
  },
  {
    country_id: 126,
    name: 'Liechtenstein',
    capital: 'Vaduz',
    format: null,
    calling_code: '+423',
    emoji: '🇱🇮',
  },
  {
    country_id: 127,
    name: 'Lithuania',
    capital: 'Vilnius',
    format: null,
    calling_code: '+370',
    emoji: '🇱🇹',
  },
  {
    country_id: 128,
    name: 'Luxembourg',
    capital: 'Luxembourg',
    format: null,
    calling_code: '+352',
    emoji: '🇱🇺',
  },
  {
    country_id: 129,
    name: 'Macau',
    capital: 'Unknown',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 130,
    name: 'Madagascar',
    capital: 'Antananarivo',
    format: null,
    calling_code: '+261',
    emoji: '🇲🇬',
  },
  {
    country_id: 131,
    name: 'Malawi',
    capital: 'Lilongwe',
    format: null,
    calling_code: '+265',
    emoji: '🇲🇼',
  },
  {
    country_id: 132,
    name: 'Malaysia',
    capital: 'Kuala Lumpur',
    format: null,
    calling_code: '+60',
    emoji: '🇲🇾',
  },
  {
    country_id: 133,
    name: 'Maldives',
    capital: 'Malé',
    format: null,
    calling_code: '+960',
    emoji: '🇲🇻',
  },
  {
    country_id: 134,
    name: 'Mali',
    capital: 'Bamako',
    format: null,
    calling_code: '+223',
    emoji: '🇲🇱',
  },
  {
    country_id: 135,
    name: 'Malta',
    capital: 'Valletta',
    format: null,
    calling_code: '+356',
    emoji: '🇲🇹',
  },
  {
    country_id: 136,
    name: 'Marshall Islands',
    capital: 'Majuro',
    format: null,
    calling_code: '+692',
    emoji: '🇲🇭',
  },
  {
    country_id: 137,
    name: 'Martinique',
    capital: 'Fort-de-France',
    format: null,
    calling_code: '+596',
    emoji: '🇲🇶',
  },
  {
    country_id: 138,
    name: 'Mauritania',
    capital: 'Nouakchott',
    format: null,
    calling_code: '+222',
    emoji: '🇲🇷',
  },
  {
    country_id: 139,
    name: 'Mauritius',
    capital: 'Port Louis',
    format: null,
    calling_code: '+230',
    emoji: '🇲🇺',
  },
  {
    country_id: 140,
    name: 'Mayotte',
    capital: 'Mamoudzou',
    format: null,
    calling_code: '+262',
    emoji: '🇾🇹',
  },
  {
    country_id: 141,
    name: 'Mexico',
    capital: 'Mexico City',
    format: null,
    calling_code: '+52',
    emoji: '🇲🇽',
  },
  {
    country_id: 142,
    name: 'Micronesia',
    capital: 'Palikir',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 143,
    name: 'Moldova',
    capital: 'Chișinău',
    format: null,
    calling_code: '+373',
    emoji: '🇲🇩',
  },
  {
    country_id: 144,
    name: 'Monaco',
    capital: 'Monaco',
    format: null,
    calling_code: '+377',
    emoji: '🇲🇨',
  },
  {
    country_id: 145,
    name: 'Mongolia',
    capital: 'Ulan Bator',
    format: null,
    calling_code: '+976',
    emoji: '🇲🇳',
  },
  {
    country_id: 146,
    name: 'Montenegro',
    capital: 'Podgorica',
    format: null,
    calling_code: '+382',
    emoji: '🇲🇪',
  },
  {
    country_id: 147,
    name: 'Montserrat',
    capital: 'Plymouth',
    format: null,
    calling_code: '+1 664',
    emoji: '🇲🇸',
  },
  {
    country_id: 148,
    name: 'Morocco',
    capital: 'Rabat',
    format: null,
    calling_code: '+212',
    emoji: '🇲🇦',
  },
  {
    country_id: 149,
    name: 'Mozambique',
    capital: 'Maputo',
    format: null,
    calling_code: '+258',
    emoji: '🇲🇿',
  },
  {
    country_id: 150,
    name: 'Myanmar',
    capital: 'Naypyidaw',
    format: null,
    calling_code: '+95',
    emoji: '🇲🇲',
  },
  {
    country_id: 151,
    name: 'Namibia',
    capital: 'Windhoek',
    format: null,
    calling_code: '+264',
    emoji: '🇳🇦',
  },
  {
    country_id: 152,
    name: 'Nauru',
    capital: 'Yaren',
    format: null,
    calling_code: '+674',
    emoji: '🇳🇷',
  },
  {
    country_id: 153,
    name: 'Nepal',
    capital: 'Kathmandu',
    format: null,
    calling_code: '+977',
    emoji: '🇳🇵',
  },
  {
    country_id: 154,
    name: 'Netherlands',
    capital: 'Amsterdam',
    format: null,
    calling_code: '+31',
    emoji: '🇳🇱',
  },
  {
    country_id: 155,
    name: 'New Caledonia',
    capital: 'Nouméa',
    format: null,
    calling_code: '+687',
    emoji: '🇳🇨',
  },
  {
    country_id: 156,
    name: 'New Zealand',
    capital: 'Wellington',
    format: null,
    calling_code: '+64',
    emoji: '🇳🇿',
  },
  {
    country_id: 157,
    name: 'Nicaragua',
    capital: 'Managua',
    format: null,
    calling_code: '+505',
    emoji: '🇳🇮',
  },
  {
    country_id: 158,
    name: 'Niger',
    capital: 'Niamey',
    format: null,
    calling_code: '+227',
    emoji: '🇳🇪',
  },
  {
    country_id: 159,
    name: 'Nigeria',
    capital: 'Abuja',
    format: null,
    calling_code: '+234',
    emoji: '🇳🇬',
  },
  {
    country_id: 160,
    name: 'Niue',
    capital: 'Alofi',
    format: null,
    calling_code: '+683',
    emoji: '🇳🇺',
  },
  {
    country_id: 161,
    name: 'Norfolk Island',
    capital: 'Kingston',
    format: null,
    calling_code: '+672',
    emoji: '🇳🇫',
  },
  {
    country_id: 162,
    name: 'North Korea',
    capital: 'Pyongyang',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 163,
    name: 'North Macedonia',
    capital: 'Skopje',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 164,
    name: 'Northern Mariana Islands',
    capital: 'Saipan',
    format: null,
    calling_code: '+1 670',
    emoji: '🇲🇵',
  },
  {
    country_id: 165,
    name: 'Norway',
    capital: 'Oslo',
    format: null,
    calling_code: '+47',
    emoji: '🇳🇴',
  },
  {
    country_id: 166,
    name: 'Oman',
    capital: 'Muscat',
    format: null,
    calling_code: '+968',
    emoji: '🇴🇲',
  },
  {
    country_id: 167,
    name: 'Pakistan',
    capital: 'Islamabad',
    format: null,
    calling_code: '+92',
    emoji: '🇵🇰',
  },
  {
    country_id: 168,
    name: 'Palau',
    capital: 'Ngerulmud',
    format: null,
    calling_code: '+680',
    emoji: '🇵🇼',
  },
  {
    country_id: 169,
    name: 'Palestine',
    capital: 'Ramallah',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 170,
    name: 'Panama',
    capital: 'Panama City',
    format: null,
    calling_code: '+507',
    emoji: '🇵🇦',
  },
  {
    country_id: 171,
    name: 'Papua New Guinea',
    capital: 'Port Moresby',
    format: null,
    calling_code: '+675',
    emoji: '🇵🇬',
  },
  {
    country_id: 172,
    name: 'Paraguay',
    capital: 'Asunción',
    format: null,
    calling_code: '+595',
    emoji: '🇵🇾',
  },
  {
    country_id: 173,
    name: 'Peru',
    capital: 'Lima',
    format: null,
    calling_code: '+51',
    emoji: '🇵🇪',
  },
  {
    country_id: 174,
    name: 'Philippines',
    capital: 'Manila',
    format: null,
    calling_code: '+63',
    emoji: '🇵🇭',
  },
  {
    country_id: 175,
    name: 'Pitcairn Islands',
    capital: 'Adamstown',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 176,
    name: 'Poland',
    capital: 'Warsaw',
    format: null,
    calling_code: '+48',
    emoji: '🇵🇱',
  },
  {
    country_id: 177,
    name: 'Portugal',
    capital: 'Lisbon',
    format: null,
    calling_code: '+351',
    emoji: '🇵🇹',
  },
  {
    country_id: 178,
    name: 'Puerto Rico',
    capital: 'San Juan',
    format: null,
    calling_code: '+1 787',
    emoji: '🇵🇷',
  },
  {
    country_id: 179,
    name: 'Qatar',
    capital: 'Doha',
    format: null,
    calling_code: '+974',
    emoji: '🇶🇦',
  },
  {
    country_id: 180,
    name: 'Republic of the Congo',
    capital: 'Brazzaville',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 181,
    name: 'Romania',
    capital: 'Bucharest',
    format: null,
    calling_code: '+40',
    emoji: '🇷🇴',
  },
  {
    country_id: 182,
    name: 'Russia',
    capital: 'Moscow',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 183,
    name: 'Rwanda',
    capital: 'Kigali',
    format: null,
    calling_code: '+250',
    emoji: '🇷🇼',
  },
  {
    country_id: 184,
    name: 'Réunion',
    capital: 'Saint-Denis',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 185,
    name: 'Saint Barthélemy',
    capital: 'Gustavia',
    format: null,
    calling_code: '+590',
    emoji: '🇧🇱',
  },
  {
    country_id: 186,
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    capital: 'Jamestown',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 187,
    name: 'Saint Kitts and Nevis',
    capital: 'Basseterre',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 188,
    name: 'Saint Lucia',
    capital: 'Castries',
    format: null,
    calling_code: '+1 758',
    emoji: '🇱🇨',
  },
  {
    country_id: 189,
    name: 'Saint Martin',
    capital: 'Marigot',
    format: null,
    calling_code: '+590',
    emoji: '🇲🇫',
  },
  {
    country_id: 190,
    name: 'Saint Pierre and Miquelon',
    capital: 'Saint-Pierre',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 191,
    name: 'Saint Vincent and the Grenadines',
    capital: 'Kingstown',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 192,
    name: 'Samoa',
    capital: 'Apia',
    format: null,
    calling_code: '+685',
    emoji: '🇼🇸',
  },
  {
    country_id: 193,
    name: 'San Marino',
    capital: 'City of San Marino',
    format: null,
    calling_code: '+378',
    emoji: '🇸🇲',
  },
  {
    country_id: 194,
    name: 'Saudi Arabia',
    capital: 'Riyadh',
    format: null,
    calling_code: '+966',
    emoji: '🇸🇦',
  },
  {
    country_id: 195,
    name: 'Senegal',
    capital: 'Dakar',
    format: null,
    calling_code: '+221',
    emoji: '🇸🇳',
  },
  {
    country_id: 196,
    name: 'Serbia',
    capital: 'Belgrade',
    format: null,
    calling_code: '+381',
    emoji: '🇷🇸',
  },
  {
    country_id: 197,
    name: 'Seychelles',
    capital: 'Victoria',
    format: null,
    calling_code: '+248',
    emoji: '🇸🇨',
  },
  {
    country_id: 198,
    name: 'Sierra Leone',
    capital: 'Freetown',
    format: null,
    calling_code: '+232',
    emoji: '🇸🇱',
  },
  {
    country_id: 199,
    name: 'Singapore',
    capital: 'Singapore',
    format: null,
    calling_code: '+65',
    emoji: '🇸🇬',
  },
  {
    country_id: 200,
    name: 'Sint Maarten',
    capital: 'Philipsburg',
    format: null,
    calling_code: '+1 721',
    emoji: '🇸🇽',
  },
  {
    country_id: 201,
    name: 'Slovakia',
    capital: 'Bratislava',
    format: null,
    calling_code: '+421',
    emoji: '🇸🇰',
  },
  {
    country_id: 202,
    name: 'Slovenia',
    capital: 'Ljubljana',
    format: null,
    calling_code: '+386',
    emoji: '🇸🇮',
  },
  {
    country_id: 203,
    name: 'Solomon Islands',
    capital: 'Honiara',
    format: null,
    calling_code: '+677',
    emoji: '🇸🇧',
  },
  {
    country_id: 204,
    name: 'Somalia',
    capital: 'Mogadishu',
    format: null,
    calling_code: '+252',
    emoji: '🇸🇴',
  },
  {
    country_id: 205,
    name: 'South Africa',
    capital: 'Pretoria',
    format: null,
    calling_code: '+27',
    emoji: '🇿🇦',
  },
  {
    country_id: 206,
    name: 'South Georgia',
    capital: 'King Edward Point',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 207,
    name: 'South Korea',
    capital: 'Seoul',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 208,
    name: 'South Sudan',
    capital: 'Juba',
    format: null,
    calling_code: '+211',
    emoji: '🇸🇸',
  },
  {
    country_id: 209,
    name: 'Spain',
    capital: 'Madrid',
    format: null,
    calling_code: '+34',
    emoji: '🇪🇸',
  },
  {
    country_id: 210,
    name: 'Sri Lanka',
    capital: 'Sri Jayawardenepura Kotte',
    format: null,
    calling_code: '+94',
    emoji: '🇱🇰',
  },
  {
    country_id: 211,
    name: 'Sudan',
    capital: 'Khartoum',
    format: null,
    calling_code: '+249',
    emoji: '🇸🇩',
  },
  {
    country_id: 212,
    name: 'Suriname',
    capital: 'Paramaribo',
    format: null,
    calling_code: '+597',
    emoji: '🇸🇷',
  },
  {
    country_id: 213,
    name: 'Svalbard and Jan Mayen',
    capital: 'Longyearbyen',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 214,
    name: 'Sweden',
    capital: 'Stockholm',
    format: null,
    calling_code: '+46',
    emoji: '🇸🇪',
  },
  {
    country_id: 215,
    name: 'Switzerland',
    capital: 'Bern',
    format: null,
    calling_code: '+41',
    emoji: '🇨🇭',
  },
  {
    country_id: 216,
    name: 'Syria',
    capital: 'Damascus',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 217,
    name: 'São Tomé and Príncipe',
    capital: 'São Tomé',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 218,
    name: 'Taiwan',
    capital: 'Taipei',
    format: null,
    calling_code: '+886',
    emoji: '🇹🇼',
  },
  {
    country_id: 219,
    name: 'Tajikistan',
    capital: 'Dushanbe',
    format: null,
    calling_code: '+992',
    emoji: '🇹🇯',
  },
  {
    country_id: 220,
    name: 'Tanzania',
    capital: 'Dodoma',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 221,
    name: 'Thailand',
    capital: 'Bangkok',
    format: null,
    calling_code: '+66',
    emoji: '🇹🇭',
  },
  {
    country_id: 222,
    name: 'Timor-Leste',
    capital: 'Dili',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 223,
    name: 'Togo',
    capital: 'Lomé',
    format: null,
    calling_code: '+228',
    emoji: '🇹🇬',
  },
  {
    country_id: 224,
    name: 'Tokelau',
    capital: 'Fakaofo',
    format: null,
    calling_code: '+690',
    emoji: '🇹🇰',
  },
  {
    country_id: 225,
    name: 'Tonga',
    capital: "Nuku'alofa",
    format: null,
    calling_code: '+676',
    emoji: '🇹🇴',
  },
  {
    country_id: 226,
    name: 'Trinidad and Tobago',
    capital: 'Port of Spain',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 227,
    name: 'Tunisia',
    capital: 'Tunis',
    format: null,
    calling_code: '+216',
    emoji: '🇹🇳',
  },
  {
    country_id: 228,
    name: 'Turkey',
    capital: 'Ankara',
    format: null,
    calling_code: '+90',
    emoji: '🇹🇷',
  },
  {
    country_id: 229,
    name: 'Turkmenistan',
    capital: 'Ashgabat',
    format: null,
    calling_code: '+993',
    emoji: '🇹🇲',
  },
  {
    country_id: 230,
    name: 'Turks and Caicos Islands',
    capital: 'Cockburn Town',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 231,
    name: 'Tuvalu',
    capital: 'Funafuti',
    format: null,
    calling_code: '+688',
    emoji: '🇹🇻',
  },
  {
    country_id: 232,
    name: 'Uganda',
    capital: 'Kampala',
    format: null,
    calling_code: '+256',
    emoji: '🇺🇬',
  },
  {
    country_id: 233,
    name: 'Ukraine',
    capital: 'Kyiv',
    format: null,
    calling_code: '+380',
    emoji: '🇺🇦',
  },
  {
    country_id: 234,
    name: 'United Arab Emirates',
    capital: 'Abu Dhabi',
    format: null,
    calling_code: '+971',
    emoji: '🇦🇪',
  },
  {
    country_id: 235,
    name: 'United Kingdom',
    capital: 'London',
    format: null,
    calling_code: '+44',
    emoji: '🇬🇧',
  },
  {
    country_id: 236,
    name: 'United States of America',
    capital: 'Washington, D.C.',
    format: '(###) ###-####',
    calling_code: '+1',
    emoji: '🇺🇸',
  },
  {
    country_id: 237,
    name: 'United States Minor Outlying Islands',
    capital: 'Unknown',
    format: null,
    calling_code: '+1',
    emoji: '🇺🇲',
  },
  {
    country_id: 238,
    name: 'United States Virgin Islands',
    capital: 'Charlotte Amalie',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 239,
    name: 'Uruguay',
    capital: 'Montevideo',
    format: null,
    calling_code: '+598',
    emoji: '🇺🇾',
  },
  {
    country_id: 240,
    name: 'Uzbekistan',
    capital: 'Tashkent',
    format: null,
    calling_code: '+998',
    emoji: '🇺🇿',
  },
  {
    country_id: 241,
    name: 'Vanuatu',
    capital: 'Port Vila',
    format: null,
    calling_code: '+678',
    emoji: '🇻🇺',
  },
  {
    country_id: 242,
    name: 'Vatican City',
    capital: 'Vatican City',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 243,
    name: 'Venezuela',
    capital: 'Caracas',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 244,
    name: 'Vietnam',
    capital: 'Hanoi',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 245,
    name: 'Wallis and Futuna',
    capital: 'Mata-Utu',
    format: null,
    calling_code: '',
    emoji: '',
  },
  {
    country_id: 246,
    name: 'Western Sahara',
    capital: 'El Aaiún',
    format: null,
    calling_code: '+212',
    emoji: '🇪🇭',
  },
  {
    country_id: 247,
    name: 'Yemen',
    capital: "Sana'a",
    format: null,
    calling_code: '+967',
    emoji: '🇾🇪',
  },
  {
    country_id: 248,
    name: 'Zambia',
    capital: 'Lusaka',
    format: null,
    calling_code: '+260',
    emoji: '🇿🇲',
  },
  {
    country_id: 249,
    name: 'Zimbabwe',
    capital: 'Harare',
    format: null,
    calling_code: '+263',
    emoji: '🇿🇼',
  },
  {
    country_id: 250,
    name: 'Åland Islands',
    capital: 'Mariehamn',
    format: null,
    calling_code: '+358',
    emoji: '🇦🇽',
  },
];

export type TCountryObj = (typeof countries)[number];
